<!-- @veltra/icons generated sha256:2d8a66774ac47178 gen:8 source:src/svg/normal/vertical-align-center.svg -->
<script setup lang="ts">
defineOptions({ name: 'VerticalAlignCenter' })
</script>
<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
    <path
      fill="currentColor"
      fill-rule="evenodd"
      d="M13.494 3H2.506A.507.507 0 0 1 2 2.504C2 2.228 2.23 2 2.506 2h10.988c.276 0 .506.228.506.496 0 .276-.23.504-.506.504m-2.003 3.5H4.509A.51.51 0 0 1 4 6.004c0-.276.233-.504.51-.504h6.98a.51.51 0 0 1 .51.496.51.51 0 0 1-.51.504m2.003 3.5H2.506A.507.507 0 0 1 2 9.504C2 9.228 2.23 9 2.506 9h10.988c.276 0 .506.228.506.496 0 .276-.23.504-.506.504M4.51 13.5h6.982a.51.51 0 0 0 .509-.496.51.51 0 0 0-.51-.504H4.51a.51.51 0 0 0-.51.496c0 .276.233.504.51.504"
    />
  </svg>
</template>
